(()=>{
 if(window.tfbHomeInstalled)return;window.tfbHomeInstalled=true;
 function init(){
  document.querySelectorAll('.tfb-home-intro').forEach(root=>{
   if(root.dataset.tfbReady)return;root.dataset.tfbReady='true';
   const tabs=[...root.querySelectorAll('[role="tab"]')];
   function select(tab){tabs.forEach(t=>{const active=t===tab;t.setAttribute('aria-selected',String(active));t.tabIndex=active?0:-1;const panel=root.querySelector('#'+t.getAttribute('aria-controls'));if(panel)panel.hidden=!active})}
   tabs.forEach((tab,index)=>{tab.addEventListener('click',()=>select(tab));tab.addEventListener('keydown',e=>{if(!['ArrowRight','ArrowLeft','Home','End'].includes(e.key))return;e.preventDefault();const i=e.key==='Home'?0:e.key==='End'?tabs.length-1:(index+(e.key==='ArrowRight'?1:-1)+tabs.length)%tabs.length;select(tabs[i]);tabs[i].focus()})});
  });
  const featured=document.querySelector('.shopify-section[id$="__featured_collections_bnWBNC"]');
  // Les snippets ajoutent aussi des balises style/script : elles ne sont pas des cartes.
  if(featured)featured.querySelectorAll('scroll-carousel.product-list').forEach(carousel=>{
   if(carousel.dataset.tfbCardCellsReady)return;
   carousel.setAttribute('cell-selector','.product-card-wrapper');
   if(typeof carousel.select==='function')carousel.select(0,{instant:true});
   carousel.dataset.tfbCardCellsReady='true';
  });
  if(featured&&!featured.dataset.tfbReady){
   featured.dataset.tfbReady='true';
   const linkConfig=document.getElementById('tfb-home-collection-links');
   let links=[];try{links=JSON.parse(linkConfig?.textContent||'[]')}catch{}
   featured.querySelectorAll('.featured-collections-carousel__item').forEach((item,index)=>{
    const definition=links[index];if(!definition?.url)return;
    const existing=[...item.querySelectorAll('a')].find(a=>a.getAttribute('href')===definition.url);
    const link=existing||document.createElement('a');link.href=definition.url;link.className='tfb-home-view-more';link.textContent=definition.label||'Voir plus';item.append(link);
   });
   featured.querySelectorAll('.product-card').forEach(card=>{
    const info=card.querySelector('.product-card__info');
    if(info&&!card.querySelector('.product-card__swatch-list')){const slot=document.createElement('div');slot.className='product-card__swatch-list';slot.setAttribute('aria-hidden','true');info.append(slot)}
   });

   featured.querySelectorAll('quick-buy-modal').forEach(modal=>{modal.classList.add('tfb-quick-buy-modal');featured.querySelectorAll('button[aria-controls]').forEach(button=>{if(button.getAttribute('aria-controls')===modal.id){button.classList.remove('product-card__quick-add-button');button.classList.add('tfb-home-quick-buy-trigger')}})});
   featured.querySelectorAll('.product-card').forEach(card=>{const actions=card.querySelector('.product-card__actions-wrapper');if(actions)card.append(actions)});
   const nav=featured.querySelector('.featured-collections-navigation');
   if(nav){[...nav.querySelectorAll('button')].forEach((button,index)=>{if(index<2)button.textContent=index===0?'Nouveautés':'Best-sellers'});const heading=document.createElement('div');heading.className='tfb-home-featured-heading';const kicker=document.createElement('p');kicker.className='tfb-home-kicker';kicker.textContent='NOTRE SÉLECTION';const title=document.createElement('h2');title.textContent='Les nouveautés';heading.append(kicker,title);nav.parentElement.prepend(heading);
    function update(){const buttons=[...nav.querySelectorAll('button')];title.textContent=buttons.findIndex(b=>b.getAttribute('aria-current')==='true')===1?'Les best-sellers':'Les nouveautés'}
    new MutationObserver(update).observe(nav,{attributes:true,subtree:true,attributeFilter:['aria-current']});update();
   }
  }
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
 document.addEventListener('shopify:section:load',init);
})();

/* Harmoniser le sujet visible, même si les fichiers contiennent des marges blanches. */
(()=>{
 if(window.tfbHomeImageFramingInstalled)return;window.tfbHomeImageFramingInstalled=true;
 const selector='.shopify-section[id$="__featured_collections_bnWBNC"] .product-card__media img';
 const cache=new Map(),watched=new WeakSet(),bounds=new WeakMap();
 const resize=new ResizeObserver(entries=>entries.forEach(e=>apply(e.target)));
 function apply(img){
  const b=bounds.get(img);if(!b||!img.clientWidth||!img.clientHeight)return;
  const w=img.clientWidth,h=img.clientHeight,base=Math.min(w/b.iw,h/b.ih);
  const wanted=Math.min(w*.90/b.width,h*.90/b.height);
  const scale=Math.min(4,Math.max(.6,wanted/base));
  img.style.setProperty('--tfb-image-scale',scale.toFixed(4));
  img.style.setProperty('--tfb-image-x',((b.iw/2-b.cx)*base*scale).toFixed(2)+'px');
  img.style.setProperty('--tfb-image-y',((b.ih/2-b.cy)*base*scale).toFixed(2)+'px');
  img.classList.add('tfb-home-image-framed');
 }
 function analyze(source){
  if(cache.has(source))return cache.get(source);
  const work=new Promise(resolve=>{
   const probe=new Image();probe.crossOrigin='anonymous';
   probe.onload=()=>{try{
    const iw=probe.naturalWidth,ih=probe.naturalHeight;
    const ratio=Math.min(1,240/Math.max(iw,ih));
    const canvas=document.createElement('canvas');canvas.width=Math.max(1,Math.round(iw*ratio));canvas.height=Math.max(1,Math.round(ih*ratio));
    const ctx=canvas.getContext('2d',{willReadFrequently:true});ctx.drawImage(probe,0,0,canvas.width,canvas.height);
    const {data}=ctx.getImageData(0,0,canvas.width,canvas.height),cw=canvas.width,ch=canvas.height;
    const at=(x,y)=>{const i=(y*cw+x)*4;return [data[i],data[i+1],data[i+2],data[i+3]]};
    const corners=[at(0,0),at(cw-1,0),at(0,ch-1),at(cw-1,ch-1)];
    const transparent=corners.filter(p=>p[3]<32).length>=3;
    const bg=[0,1,2].map(k=>corners.reduce((sum,p)=>sum+p[k],0)/4);
    // Les photos avec un fond coloré gardent leur cadrage original.
    if(!transparent&&Math.min(...bg)<210){resolve(null);return;}
    let x0=cw,y0=ch,x1=-1,y1=-1,count=0;
    for(let y=0;y<ch;y++)for(let x=0;x<cw;x++){
     const i=(y*cw+x)*4;
     const content=data[i+3]>32&&(transparent||Math.max(Math.abs(data[i]-bg[0]),Math.abs(data[i+1]-bg[1]),Math.abs(data[i+2]-bg[2]))>24);
     if(content){x0=Math.min(x0,x);x1=Math.max(x1,x);y0=Math.min(y0,y);y1=Math.max(y1,y);count++;}
    }
    if(x1<x0||count<cw*ch*.015){resolve(null);return;}
    // Ajouter une petite marge pour conserver les contours clairs du produit.
    const pad=Math.max(1,Math.round(Math.max(x1-x0+1,y1-y0+1)*.02));x0=Math.max(0,x0-pad);x1=Math.min(cw-1,x1+pad);y0=Math.max(0,y0-pad);y1=Math.min(ch-1,y1+pad);
    resolve({iw,ih,width:(x1-x0+1)/cw*iw,height:(y1-y0+1)/ch*ih,cx:(x0+x1+1)/2/cw*iw,cy:(y0+y1+1)/2/ch*ih});
   }catch{resolve(null);}};
   probe.onerror=()=>resolve(null);
   // Lire une miniature du même fichier pour limiter le coût de l'analyse.
   try{const url=new URL(source,location.href);if(url.hostname==='thefactorybusiness.com'||url.hostname.endsWith('shopify.com'))url.searchParams.set('width','240');probe.src=url.href;}catch{resolve(null);}
  });cache.set(source,work);return work;
 }
 async function frame(img){
  if(!img.complete||!img.naturalWidth)return;
  const source=img.currentSrc||img.src;img.dataset.tfbFramingSource=source;
  const b=await analyze(source);
  if(!img.isConnected||img.dataset.tfbFramingSource!==source||(img.currentSrc||img.src)!==source)return;
  if(b){bounds.set(img,b);apply(img);}else{bounds.delete(img);img.classList.remove('tfb-home-image-framed');}
 }
 function scan(){document.querySelectorAll(selector).forEach(img=>{
  if(watched.has(img))return;watched.add(img);resize.observe(img);
  img.addEventListener('load',()=>frame(img));frame(img);
  new MutationObserver(()=>{bounds.delete(img);img.classList.remove('tfb-home-image-framed');frame(img);}).observe(img,{attributes:true,attributeFilter:['src','srcset']});
 })}
 let scheduled=false;
 new MutationObserver(()=>{if(scheduled)return;scheduled=true;requestAnimationFrame(()=>{scheduled=false;scan()})}).observe(document.documentElement,{childList:true,subtree:true});
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan);else scan();
})();
